module.exports = __webpack_public_path__ + "static/media/ZhiXiao3.095b4378.png";